import { render, staticRenderFns } from "./SignOutButton.vue?vue&type=template&id=0b8be054&scoped=true&"
import script from "./SignOutButton.vue?vue&type=script&lang=js&"
export * from "./SignOutButton.vue?vue&type=script&lang=js&"
import style0 from "./SignOutButton.vue?vue&type=style&index=0&id=0b8be054&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8be054",
  null
  
)

export default component.exports